import React from "react";
import i18n from "i18next";

/* eslint-disable react/prop-types */

export default function VideoCardElement({ element, onActions }) {
  const {
    videoUrl = "",
    autoPlay = false,
    caption = "",
    captionAlign = "left",
    buttons = [],
  } = element;

  return (
    <div className="sce-videocard">
      {videoUrl ? (
        <video
          src={videoUrl}
          controls
          autoPlay={autoPlay}
          className="sce-videocard__video"
          onEnded={() => {}}
        />
      ) : (
        <div className="sce-videocard__placeholder">
          <span className="material-icons" style={{ fontSize: 40, color: "#64748b" }}>
            videocam
          </span>
          <span style={{ fontSize: 13, color: "#64748b", marginTop: 8 }}>
            {i18n.t("InteractiveScenario.Placeholder.AddVideoHint") || "Video ekleyin"}
          </span>
        </div>
      )}

      {caption && (
        <p className="sce-videocard__caption" style={{ textAlign: captionAlign }}>
          {caption}
        </p>
      )}

      {buttons.length > 0 && (
        <div className="sce-videocard__buttons">
          {buttons.map((btn) => (
            <button
              key={btn.id}
              type="button"
              className={`sce-btn sce-btn--${btn.style || "primary"}`}
              onClick={() => onActions(btn.actions || [])}
            >
              {btn.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
